import {Button} from 'antd';
import Flex from 'components/shared-components/Flex';
import React, {useEffect, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory, useParams} from 'react-router-dom';
import {getInvoiceByAccessCode} from 'redux/actions';
import EstService from 'services/EstService';
import NotificationService from 'services/NotificationService';
import {DataUtils} from 'utils/DataUtils';
import initializeCanvas, {getDataUrl} from './signInvoice';
import HelperService from "../../../../services/HelperService";

const CANVAS_SELECTOR = '.sign-canvas';

const SignInvoice = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const params = useParams();
  const { invoice } = useSelector((s) => s.invoices);
  const canvasRef = useRef(null);

  useEffect(() => {
    if (canvasRef.current) {
      initializeCanvas(CANVAS_SELECTOR);
    }
  }, [canvasRef]);

  useEffect(() => {
    if (params.access_code) {
      dispatch(getInvoiceByAccessCode(params.invoice_id, params.access_code));
    }
  }, [params, dispatch]);

  const handleApprove = async () => {
    try {
      const dataUrl = getDataUrl(CANVAS_SELECTOR);
      const signatureBlob = DataUtils.dataURItoBlob(dataUrl);
      await EstService.postApproveInvoice(
        params.invoice_id,
        params.access_code,
        signatureBlob
      );
      NotificationService.success('Successfully approved invoice.');
      // Take the user to the details of the invoice
      history.replace(`/i/${params.invoice_id}/${params.access_code}`);
    } catch (err) {
      console.error(err);
      NotificationService.error('There was a problem while approving invoice.');
    }
  };

  return (
    <Flex flexDirection="column" alignItems="center">
      <h2 className="mt-3">
        Do you want to approve the invoice for {HelperService.currency(invoice?.grand_total)}?
      </h2>

      <canvas ref={canvasRef} className="sign-canvas mt-2">
        Could not render canvas
      </canvas>

      <Button
        className="mt-3"
        type="primary"
        shape="round"
        onClick={handleApprove}
      >
        Approve
      </Button>
    </Flex>
  );
};

export default SignInvoice;
